export default function(d) {
  return d;
}



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/_storageApp.Front.release/~/d3-shape/src/identity.js
// module id = ../../../../d3-shape/src/identity.js
// module chunks = 4